import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Grid from '@mui/material/Grid';

import {styleAlphabet} from "../../assets/alphabet/alphabet";
import FormRow from "../formRow";

const useStyles = makeStyles((theme) => ({
  greed: {
    marginLeft: '-4px !important',
    paddingTop: '8px'
  },
}));

export default function NestedGrid(props) {
  const classes = useStyles();
  const alphabet = props.gameAlphabet || styleAlphabet;

  return (
    <Grid container  spacing={{xs:1, md: 3, lg :1}} className={classes.greed}>
      <FormRow styleLaters={alphabet} {...props} />
    </Grid>
  );
}
